import { render, staticRenderFns } from "./time-spinner.vue?vue&type=template&id=c5a6df44"
import script from "./time-spinner.vue?vue&type=script&lang=js"
export * from "./time-spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports